<main class="together-page">
    <div class="together-page-content">
            <together-page-content></together-page-content>
    </div>
</main>